<div class="mb-3">{{ userNotes }}</div>

<app-infobox-table [data]="infoboxData"></app-infobox-table>
